module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ContentHeader":{"alt":"Obrázek kategorie {category}"}},"en":{"ContentHeader":{"alt":"Category image"}}}')
  delete Component.options._Ctor
}
